import { Directive } from "@angular/core";
import {
	Input,
	Output,
	OnChanges,
	EventEmitter,
	ElementRef,
	HostListener,
	ChangeDetectorRef,
} from "@angular/core";

@Directive({
	selector: "[makeDropable]",
})
export class DropableDirective {
	private el: HTMLElement;
	@Output() dropped: EventEmitter<any> = new EventEmitter<any>();
	constructor(
		private elementRef: ElementRef,
		private changeDetector: ChangeDetectorRef
	) {
		this.el = elementRef.nativeElement;
	}
	ngOnInit() {
		let _owner: any = this;
		this.el.ondrop = function (event) {
			event.preventDefault();
			let data = event.dataTransfer.getData("text");
			//console.log( 'ondrop data  :', data);
			_owner.emitDropEvent(data);
		};
		this.el.ondragover = function (event) {
			event.preventDefault();
		};
	}
	emitDropEvent(data) {
		//console.log('emitDropEvent :', data);
		this.dropped.emit(data);
	}
}
